'use strict';

angular.module('sellersService')
.factory('PostService', ['$log', '$rootScope', '$http', '$q', 'CacheFactory', 'Base64', 'appInfo', 'AgencyService'
    , function ($log, $rootScope, $http, $q, CacheFactory,  Base64, appInfo, AgencyService) {

         // var currentUser = $rootScope.currentUser;
         // var currentListing = $rootScope.currentListing;
         // var currentListingAgent = $rootScope.currentListing.agentInfo;
         // var agentIdentifier = currentListingAgent.agency[0].identifier;
         
         // var key = currentUser.authdata;
        
        var currentUser = '';
        var currentListing ='';
        var currentListingAgent ='';
        var agentIdentifier = '';
         
        var key = '';


        var service = {}
             , api_key = appInfo.pkey
             , endpoint = appInfo.endpoint
             , expiry = moment().add(15, 'm').unix();

        

        var initCurrentListingVars = function() {
             currentUser = $rootScope.currentUser;
             currentListing = $rootScope.currentListing;
             currentListingAgent = $rootScope.currentListing.agentInfo;
             //agentIdentifier = currentListingAgent.agency[0].identifier;
             agentIdentifier = currentListing.propertyOrganisation.identifier;
             key = currentUser.authdata;
        }

        // // Add new or Update to do item
        // service.updatePost = function(updatedItem) {
        //     var dfd = $q.defer();

        //     if (updatedItem.id > 0) {
        //         //Setup data object
        //         var updatedPost = {
        //             usercode: key,
        //             id: updatedItem.id,
        //             postType: updatedItem.postType,
        //             data: {
        //                 message: updatedItem.message.replace(/\n/g, "<br />"),
        //                 imgUrls: updatedItem.imgUrls,
        //                 videoUrl: updatedItem.videoUrl,
        //                 tags: updatedItem.tags,
        //             }
        //         };

        //         $http({
        //             url: endpoint+'agency/updatefeed.json',
        //             method: "POST",
        //             params: { api_key: api_key },
        //             data: updatedPost
        //         }).success(function(data) {
        //             dfd.resolve(data);
        //         }).error(function(data, status, headers, config) {
        //             dfd.reject("Error: request returned status " + status);
        //         });
        //     } else {
        //         dfd.reject("Error: no post id specified ");
        //     }

        //     return dfd.promise;
        // };

        // Add new or Update to do item
        service.saveNewPost = function(newItem) {
            initCurrentListingVars();
            var dfd = $q.defer();
            //Setup data object
            var newPost = {
                usercode: key,
                identifier: agentIdentifier,
                owner: currentUser.id,
                postType: newItem.postType,
                data: {
                    message: newItem.message.replace(/\n/g, "<br />"),
                    imgUrls: newItem.imgUrls,
                    videoUrl: newItem.videoUrl,
                    tags: newItem.tags,
                }
            };

            $http({
                    url: endpoint+'agency/feed.json', 
                    method: "POST",
                    params: { api_key: api_key },
                    data: newPost
                }).success(function(data) {
                    dfd.resolve(data);
                }).error(function(data, status, headers, config) {
                    dfd.reject("Error: request returned status " + status); 
                });

            return dfd.promise;
        };


        service.getPosts = function(filter, pageSize, showBeforePostId) {
            initCurrentListingVars();
            var dfd = $q.defer();
            var dataParams = { usercode: key, pageSize: pageSize, showbeforepostid: showBeforePostId, postType: "1,3" };
            switch(filter.filterType) {
                case 'propertyRelated':
                    dataParams.status = '0,1';
                    dataParams.propertyRef = currentListing.propertyRef;
                    break;
                // case 'pending':
                //     dataParams.status = '0';
                //     dataParams.identifier = agentIdentifier;
                //     break;
                // case 'personal':
                //     dataParams.status ='0,1';
                //     dataParams.owner = currentUser.id;
                //     break;
                // case 'organization':
                //     dataParams.status = '1';
                //     dataParams.identifier = agentIdentifier;
                //     break;
                // case 'all':
                //     dataParams.status = '0,1';
                //     dataParams.propertyRef = currentListing.propertyRef;
                //     break;
            }

            $http({
                    url: endpoint+'agency/getFeed.json', 
                    method: "POST",
                    params: {api_key: api_key},
                    data: dataParams,
                 }).success(function(data, status, headers, config) {
                    dfd.resolve(data);
                }).error(function(data, status, headers, config) {
                    dfd.reject("Error: Status " + status); 
                });

            return dfd.promise;
        };


        service.uploadFiles = function(images, scope) {
            var dfd = [];
            var i = 1;
            angular.forEach(images, function(image,i) {
              dfd.push(service.uploadFile(image, i, scope));
              i++;
            });
            return $q.all(dfd);
        }
        service.uploadFile = function(image, imageCount, scope){
            var dfd = $q.defer();
            
            const reader = new FileReader(); 
            var fileBody = '';
            
            reader.onload = function(){
              fileBody = reader.result;
              return dfd.resolve(service.uploadToS3(image, imageCount, scope,fileBody));
            };
            
            reader.readAsDataURL(image);
            return dfd.promise;
        }

        service.uploadToS3 = function(image, imageCount, scope,fileBody){

            var dfd = $q.defer();
            var file = image;

            var destinationFolder = 'public/agency/' + currentUser.identifier + '/' + currentUser.id +'/feed';
            var ts = moment().unix() + '-' + imageCount;
            var filename = file.name;
            var fileExt = filename.substr(filename.lastIndexOf('.')+1);
            
            var params = { Key: destinationFolder+'/'+ts+'.'+fileExt,FileName:filename,  FileBody:fileBody  ,ContentType: file.type, ACL: 'AES256' };
            
            var bucketName = 'buybuy-com-au';
            
            key = currentUser.authdata;

            var dataParams = {usercode: key, bucket: bucketName, params:params}
            
            //endpoint = 'http://mapp.localhost/w3/';

            $http({
                    url: endpoint+'agency/uploadToS3.json', 
                    method: "POST",
                    params: {api_key: api_key},
                    data: dataParams,
                 }).success(function(data, status, headers, config) {
                    imgUrl = 'https://buybuy-com-au.s3.amazonaws.com/'+ destinationFolder + '/'+ts+'.'+fileExt;

                     // Upload Progress
                    var index = getIndexByName(scope.images, filename);
                
                    if(index > -1) {
                        scope.images[index].uploadProgress.percent = 100;
                        scope.images[index].uploadProgress.label = '100%';
                    }
            


                    dfd.resolve(imgUrl);
                }).error(function(data, status, headers, config) {
                    dfd.reject("Error: Status " + status); 
                });

            return dfd.promise;
        }

        service.uploadFileOrg = function(image, imageCount, scope){
            initCurrentListingVars();
            var dfd = $q.defer();
            var imgUrl = '';
            // var file = image.file;
            var file = image;

            var destinationFolder = 'public/agency/' + agentIdentifier + '/' + currentUser.id +'/feed';


            // Configure The S3 Object
            AWS.config.update({ accessKeyId: awsCreds.access_key, secretAccessKey: awsCreds.secret_key });
            AWS.config.region = 'us-east-1';
            var bucket = new AWS.S3({ params: { Bucket: awsCreds.bucket, ACL: awsCreds.acl } });


            // Use a timestamp to keep the filenames unique
            var ts = moment().unix() + '-' + imageCount;
            var filename = file.name;
            var fileExt = filename.substr(filename.lastIndexOf('.')+1);
            // if(file.$ngfHeight == Math.round(file.$ngfWidth/1.5)) {
            var params = { Key: destinationFolder+'/'+ts+'.'+fileExt, ContentType: file.type, Body: file, ServerSideEncryption: 'AES256' };
            bucket.putObject(params, function (err, data) {
                if(err) {
                    // There Was An Error With the S3 Config
                    dfd.reject('Error: ' + err.message);
                }  else {
                    // Success!
                    imgUrl = 'https://buybuy-com-au.s3.amazonaws.com/'+ destinationFolder + '/'+ts+'.'+fileExt;
                    dfd.resolve(imgUrl);
                    // scope.$apply( function () {
                    //
                    //     // $scope.item.post_images = 'https://buybuy-com-au.s3.amazonaws.com/'+$scope.awsCreds.folder+'/'+ts+'.'+fileExt;
                    //
                    //     //Reset & hide progess meter
                    //     scope.progress = {image: filename, percent: 0, label:'0%', style: {width: '0%'}};
                    // });
                }
            })
            .on('httpUploadProgress', function (progress) {
                // Upload Progress
                var index = getIndexByName(scope.images, filename);
                scope.$apply(function() {
                    if(index > -1) {
                        scope.images[index].uploadProgress.percent = Math.round(progress.loaded / progress.total * 100);
                        scope.images[index].uploadProgress.label = scope.images[index].uploadProgress.percent + '%';
                    }
                });
            });
            // } else {
            //   //Image is too large for the stated dimensions
            //   alert('Your image is not having 1:5 ratio. The image you are trying to upload is '+file.$ngfWidth+'x'+file.$ngfHeight+' pixels.');
            // }


            return dfd.promise;

        }

        var getIndexByName = function(arrObjects, value){
            for (var i=0; i < arrObjects.length; i++) {
                if (arrObjects[i].name === value) {
                    return i;
                }
            }
            return -1;
        }

        service.sendPostApproveRequestEmail = function(item) {
            initCurrentListingVars();
            return AgencyService.getAgencyLeaders(agentIdentifier)
              .then(function(agents) {
                  var dfd = [];
                  var blnCurrentListingAgentLeader = false;
                  angular.forEach(agents.Leader, function(leader) {
                      if(leader.contact == currentListingAgent.id) {
                        blnCurrentListingAgentLeader = true;
                      }
                      dfd.push(service.sendEmail(leader, item));
                  });
                  if(!blnCurrentListingAgentLeader) {
                    dfd.push(service.sendEmail({ contact : currentListingAgent.id, email: currentListingAgent.info.email }, item));
                  }
                  return $q.all(dfd);
              });
        }
        service.sendEmail = function(leader, item) {

            var dfd = $q.defer();
            
            //endpoint = 'http://mapp.localhost/w3/';
            
            key = currentUser.authdata;

            var dataParams = {
                                usercode: key, 
                                toEmail: leader.email,
                                subject:'New post by : ' + currentUser.name,
                                htmlBody:getEmail(item, leader),
                                fromEmail:'no-reply@wiseberry.com.au'
                            }

            $http({
                    url: endpoint+'agency/sesEmail.json', 
                    method: "POST",
                    params: {api_key: api_key},
                    data: dataParams,
                 }).success(function(data, status, headers, config) {
                     dfd.resolve(data);
                }).error(function(data, status, headers, config) {
                    dfd.reject("Error: Status " + status); 
                });

            return dfd.promise;

        }

        service.sendEmailOrg = function(leader, item) {
            var dfd = $q.defer();

            AWS.config.update({ accessKeyId: awsSESCreds.access_key, secretAccessKey: awsSESCreds.secret_key });
            AWS.config.region = 'us-east-1';
            var  ses = new AWS.SES();
            //leader.email = 'heena.agheda@wiseberry.com.au';
            var params = {
                Destination: { /* required */
                    ToAddresses: [
                        leader.email, //leader.email
                    ]
                },
                Message: { /* required */
                    Body: { /* required */
                        Html: {
                            Data: getEmail(item, leader),
                        },
                        Text: {
                            Data: getEmail(item, leader),
                        }
                    },
                    Subject: { /* required */
                        Data: 'New post by : ' + currentUser.name,
                    }
                },
                Source: 'no-reply@wiseberry.com.au', /* required */  //no-reply@wiseberry.com.au
                ReplyToAddresses: [
                    'no-reply@wiseberry.com.au',  //no-reply@wiseberry.com.au
                    /* more items */
                ]
            };
            ses.sendEmail(params, function(err, data) {
                if (err) {
                    dfd.reject('Error: ' + err.message);
                    console.log(err, err.stack); // an error occurred
                }
                else {
                    dfd.resolve(data);
                }
            });
            return dfd.promise;
        }

         service.sendPostEmailToSeller = function() {
      
             service.getSellerEmail().then(function(bodyHTML) {

                var dfd = $q.defer();
                initCurrentListingVars();

                bodyHTML = formatPublicEmail(JSON.parse(bodyHTML));
                //replace seller name variable with value
                bodyHTML = bodyHTML.replace('{Seller First Name} {Seller Last Name}',currentUser.name);

                var dataParams = {
                                usercode: key, 
                                toEmail: currentUser.info.email,
                                subject:'Thank you for your post',
                                htmlBody:bodyHTML,
                                fromEmail:'no-reply@wiseberry.com.au'
                            }

                $http({
                    url: endpoint+'agency/sesEmail.json', 
                    method: "POST",
                    params: {api_key: api_key},
                    data: dataParams,
                 }).success(function(data, status, headers, config) {
                     dfd.resolve(data);
                }).error(function(data, status, headers, config) {
                    dfd.reject("Error: Status " + status); 
                });

            return dfd.promise;
            });
        }


        service.sendPostEmailToSellerOrg = function() {
      
             service.getSellerEmail().then(function(bodyHTML) {

                var dfd = $q.defer();
                initCurrentListingVars();

                bodyHTML = formatPublicEmail(JSON.parse(bodyHTML));
                //replace seller name variable with value
                bodyHTML = bodyHTML.replace('{Seller First Name} {Seller Last Name}',currentUser.name);

                AWS.config.update({ accessKeyId: awsSESCreds.access_key, secretAccessKey: awsSESCreds.secret_key });
                AWS.config.region = 'us-east-1';
                var  ses = new AWS.SES();

                var params = {
                Destination: { /* required */
                    ToAddresses: [
                        currentUser.info.email, //leader.email
                    ]
                },
                Message: { /* required */
                    Body: { /* required */
                        Html: {
                            Data: bodyHTML,
                        },
                        Text: {
                            Data: bodyHTML,
                        }
                    },
                    Subject: { /* required */
                        Data: 'Thank you for your post',
                    }
                },
                Source: 'no-reply@wiseberry.com.au', /* required */  //no-reply@wiseberry.com.au
                ReplyToAddresses: [
                    'no-reply@wiseberry.com.au',  //no-reply@wiseberry.com.au
                    /* more items */
                ]
            };
            ses.sendEmail(params, function(err, data) {
                if (err) {
                    dfd.reject('Error: ' + err.message);
                    console.log(err, err.stack); // an error occurred
                }
                else {
                    dfd.resolve(data);
                }
            });
            return dfd.promise;
            });
        }
        
         service.getSellerEmail = function(item) {
            //get custom html template
            initCurrentListingVars();
            
            var dfd = $q.defer();
            $http({
                url: appInfo.endpoint+'otherusers/pendingposttemplate.json', 
                method: "GET",
                params: {api_key: appInfo.key, identifier: agentIdentifier}
            }).success(function (data, status, headers, config){
                dfd.resolve(data);
            }).error(function(data, status, headers, config) {
                console.log("Error: Unable to get email template"); 
            });
            return dfd.promise;
        }


        var getEmail = function(item, leader) {
            var itemId = Base64.encode(item.id);
            var leaderContact = Base64.encode(leader.contact);
            var postType = 'Public';
            if(item.postType == 2) {
                postType = 'Private';
            } else if(item.postType == 3) {
                postType = 'Seller Post';
            } else {
                postType = 'Public';
            }
            var bodyHTML = '<p>Hi,</p>' +
                '<p>There is a new post posted by : ' + currentUser.name + '</p>'  + 
                //'<p>' + leader.email + '</p>' +
                '<br>' +
                '<hr>' +
                '<p>Details:</p>'+
                '<ul>' +
                '<li>Post Text:  ' + item.message + '</li>' +
                '<li>Post Type:  ' + postType+ '</li>' +
                '<li>Posted By:  ' + currentUser.name + '</li>';

            if (item.videoUrl && item.videoUrl != '') {
                bodyHTML = bodyHTML + '<li>Video URL:  <a href="http://www.youtube.com/embed/' + item.videoUrl + '">' + item.videoUrl + '</a></li>';    
            }

            if (item.imgUrls && item.imgUrls.length) {
                bodyHTML = bodyHTML + '<li>Images: ' + '<br><br>';
                    for(i=0; i< item.imgUrls.length; i++) {
                        bodyHTML = bodyHTML + '<img width="500px" src="' + item.imgUrls[i] + '"><br><br>';
                    }
                bodyHTML = bodyHTML + '</li>';
            }
            bodyHTML = bodyHTML + '</ul>';

            bodyHTML = bodyHTML + '<a style="text-decoration:none;color:#fff;" href="http://wiseberry.com.au/wbfeed/approve/' + itemId + '/' + leaderContact + '">' +
                 '<div style="' +
                    'width:100%;text-align:center;padding-top:15px;padding-bottom:15px;margin-top:10px;margin-bottom:10px;' +
                    'text-decoration:none;background-color: #822433;border-top-left-radius: 5px;border-top-right-radius: 5px;border-bottom-left-radius: 5px;' +
                    'border-bottom-right-radius: 5px;font-size: 24px;color: #fff;">' +
                'Approve And Post</div></a>'
                ;
            return formatEmail(bodyHTML);
        }

        var formatPublicEmail = function(bodyHTML){
            var facebook = (currentListingAgent.info.facebook)?currentListingAgent.info.facebook:'https://www.facebook.com/Wiseberry-Real-Estate-300236316702137/';
            var twitter = (currentListingAgent.info.twitter)?currentListingAgent.info.twitter:'http://www.twitter.com/wiseberry_re';
            var officePhone = '';
            angular.forEach(currentListingAgent.agency[0].info, function(value, key) {
            switch(key) {
                case "phone_-_office":
                    officePhone = value;
                    break;
                }
            });


             var emailHTML = '<!doctype html>' +
              ' <html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">' +
            ' <head>' +
            ' <title></title>' +
            ' <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">' +
            ' <style type="text/css">' +
            '*,.collapse{padding:0}.btn,.social .soc-btn{text-align:center;font-weight:700}ul.list-vertical li,ul.sidebar{list-style-type:none}.btn,ul.sidebar li a{text-decoration:none;cursor:pointer}*{margin:0;font-family:"Helvetica Neue",Helvetica,Helvetica,Arial,sans-serif}img{max-width:100%}body{-webkit-font-smoothing:antialiased;-webkit-text-size-adjust:none;width:100%!important;height:100%;background:#822433}.content table,.headerImage,table.body-wrap,table.footer-wrap,table.head-wrap{width:100%}a{color:#2BA6CB}.btn{color:#FFF;background-color:#822433;padding:10px 16px;margin-right:10px;display:inline-block}td.callout{padding:15px;background-color:#ECF8FF;margin-bottom:15px}.callout a{font-weight:700;color:#2BA6CB}table.social{background-color:#ebebeb}.social .soc-btn{padding:3px 7px;font-size:12px;margin-bottom:10px;text-decoration:none;color:#FFF;display:block}a.fb{background-color:#3B5998!important}a.tw{background-color:#1daced!important}a.gp{background-color:#DB4A39!important}a.ms{background-color:#000!important}.sidebar .soc-btn{display:block;width:100%}.header.container table td.logo{padding:15px}.header.container table td.label{padding:15px 15px 15px 0}table.footer-wrap{clear:both!important}.footer-wrap .container td.content p{border-top:1px solid #d7d7d7;padding-top:15px;font-size:10px;font-weight:700}h1,h2{font-weight:200}h1,h2,h3,h4,h5,h6{font-family:HelveticaNeue-Light,"Helvetica Neue Light","Helvetica Neue",Helvetica,Arial,"Lucida Grande",sans-serif;line-height:1.1;margin-bottom:15px}h1 small,h2 small,h3 small,h4 small,h5 small,h6 small{font-size:60%;color:#6f6f6f;line-height:1.1;text-transform:none}h1{font-size:44px;color:#822433}h2{font-size:37px;color:#822433}h3,h4{font-weight:500;color:#822433}h3{font-size:27px}h4{font-size:23px}h5,h6{font-weight:900}h5{font-size:17px;color:#822433}h6,p,ul{font-size:14px}h6{text-transform:uppercase;color:#444}.collapse{margin:0!important}p,ul{margin-bottom:10px;font-weight:400;line-height:1.6}p.lead{font-size:17px}p.last{margin-bottom:0}ul li{margin-left:5px;list-style-position:inside}ul.sidebar li,ul.sidebar li a{display:block;margin:0}ul.sidebar{background:#ebebeb;display:block}ul.sidebar li a{color:#666;padding:10px 16px;border-bottom:1px solid #777;border-top:1px solid #FFF}.cell,.column tr td,.content{padding:15px}ul.sidebar li a.last{border-bottom-width:0}ul.sidebar li a h1,ul.sidebar li a h2,ul.sidebar li a h3,ul.sidebar li a h4,ul.sidebar li a h5,ul.sidebar li a h6,ul.sidebar li a p{margin-bottom:0!important}.container,.margin{display:block!important;margin:0 auto!important;clear:both!important}.margin{background:#822433}.container{max-width:600px!important}.cell,.content,.headerImage{max-width:600px}.cell,.column-wrap,.content{margin:0 auto}.content{display:block}.cell{display:table-cell}.column{width:300px;float:left}.column-wrap{padding:0!important;max-width:600px!important}.column table{width:100%}.social .column{width:270px;min-width:269px;float:left}.clear{display:block;clear:both}@media only screen and (max-width:600px){a[class=btn]{display:block!important;margin-bottom:10px!important;background-image:none!important;margin-right:0!important}div[class=column]{width:auto!important;float:none!important}table.social div[class=column]{width:auto!important}}'+
            '</style>'+
            '</head>'+
            '<body bgcolor="#822433" topmargin="0" leftmargin="0" marginheight="0" marginwidth="0">'+                                
            '<table class="head-wrap" bgcolor="#822433">'+
                '<tr>'+
                    '<td></td>'+
                    '<td class="header container" align="">'+            
                        '<div class="content">'+
                            '<table bgcolor="#822433" >'+
                                '<tr>'+
                                    '<td><img src="http://www.wiseberry.com.au/img/logo-mailer.png" /></td>'+
                                    '<td align="right">&nbsp;</td>'+
                                '</tr>'+
                            '</table>'+
                        '</div>'+
                    '</td>'+
                    '<td></td>'+
                '</tr>'+
            '</table>'+
            '<table class="container">'+
                '<tr>'+
                    '<td class="margin" bgcolor="#822433">&nbsp;</td>'+
                    '<td  bgcolor="#FFFFFF">'+
                        '<div class="content" wb:repeatable>'+
                            '<table>'+
                                '<tr >'+
                                    '<td>'+
                                        '<div wb:edit="wbnl_content01">'+
                                            bodyHTML+
                                        '</div>'+
                                    '</td>'+
                                '</tr>'+
                            '</table>'+
                        '</div>'+
                        '<div class="content">'+
                            '<table>'+
                                '<tr>'+
                                    '<td>'+
                                        '<table bgcolor="" class="social" width="100%">'+
                                            '<tr>'+
                                                '<td>'+
                                                    '<div class="column">'+
                                                        '<table bgcolor="" cellpadding="" align="left">'+
                                                            '<tr>'+
                                                                '<td>'+                
                                                                    '<h5 class="">Connect with Us:</h5>'+
                                                                    '<p class=""><a href="'+facebook+'" class="soc-btn fb">Facebook</a> <a href="'+twitter+'" class="soc-btn tw">Twitter</a></p>'+
                                                                '</td>'+
                                                            '</tr>'+
                                                        '</table>'+
                                                    '</div>'+
                                                    '<div class="column">'+
                                                        '<table bgcolor="" cellpadding="" align="left">'+
                                                            '<tr>'+
                                                                '<td>'+                
                                                                    '<h5 class="">Contact Info:</h5>'+ 
                                                                    '<p><strong>'+currentListingAgent.agency[0].organisation+'</strong><br>'+
                                                                    currentListingAgent.agency[0].address +'<br />'+
                                                                    'Phone:'+officePhone+
                                                                    '</p>'+
                                                                '</td>'+
                                                            '</tr>'+
                                                        '</table>'+
                                                    '</div>'+
                                                    '<div class="clear"></div>'+
                                               '</td>'+
                                            '</tr>'+
                                        '</table>'+
                                    '</td>'+
                                '</tr>'+
                                '<tr>'+
                                    '<td align="center">'+
                                        '<p>'+
                                            '<a class="wblink" href="http://www.wiseberry.com.au/terms">Terms</a>'+
                                            '| <a class="wblink" href="http://www.wiseberry.com.au/privacy">Privacy</a>'+
                                            '</p>'+
                                    '</td>'+
                                '</tr>'+
                            '</table>'+
                        '</div>'+
                    '</td>'+
                    '<td class="margin" bgcolor="#822433">&nbsp;</td>'+
                '</tr>'+
            '</table>'+
            '</body>'+
            '</html>';
            return emailHTML;
        }

        var formatEmail = function(bodyHTML) {

            var emailHTML = '<!doctype html>' +
              ' <html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">' +
            ' <head>' +
            ' <title></title>' +
            ' <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">' +
            ' <style type="text/css">' +
            ' #outlook a { padding: 0; }' +
            '       .ReadMsgBody { width: 100%; }' +
            '       .ExternalClass { width: 100%; }' +
            '       .ExternalClass * { line-height:100%; }' +
            '           body { margin: 0; padding: 0; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; }' +
            '           table, td { border-collapse:collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; }' +
            '           img { border: 0; height: auto; line-height: 100%; outline: none; text-decoration: none; -ms-interpolation-mode: bicubic; }' +
            '           p { display: block; margin: 13px 0; }' +
            '       </style>' +
            '           <!--[if !mso]><!-->' +
            '            <style type="text/css">' +
            '@media only screen and (max-width:480px) {' +
                '       @-ms-viewport { width:320px; }' +
                '    @viewport { width:320px; }' +
                '               }' +
            '       </style>' +
            '           <!--<![endif]-->' +
            '           <!--[if mso]>' +
            '       <xml>' +
            '           <o:OfficeDocumentSettings>' +
            '           <o:AllowPNG/>' +
            '           <o:PixelsPerInch>96</o:PixelsPerInch>' +
            '           </o:OfficeDocumentSettings>' +
            '           </xml>' +
            '           <![endif]-->' +
            '            <style type="text/css">' +
            '  @media only screen and (min-width:480px) {' +
                '       .mj-column-per-100, * [aria-labelledby="mj-column-per-100"] { width:100%!important; }' +
                '           }' +
            '       </style>'+
            '           </head>' +
            '           <body style="background: #e8e8e8;">' +
            '             <div style="background-color:#e8e8e8;"><!--[if mso | IE]>' +
            '       <table border="0" cellpadding="0" cellspacing="0" width="600" align="center" style="width:600px;">' +
            '             <tr>' +
            '             <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;">' +
            '             <![endif]--><div style="margin:0 auto;max-width:600px;background:#830b2c;"><table cellpadding="0" cellspacing="0" style="font-size:0px;width:100%;background:#830b2c;" align="center" border="0"><tbody><tr><td style="text-align:center;vertical-align:top;font-size:0px;padding:20px 0px;padding-bottom:20px;padding-top:20px;"><!--[if mso | IE]>' +
            '        <table border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:top;width:600px;">' +
            '             <![endif]--><div aria-labelledby="mj-column-per-100" class="mj-column-per-100" style="vertical-align:top;display:inline-block;font-size:13px;text-align:left;width:100%;"><table cellpadding="0" cellspacing="0" style="vertical-align:top;" width="100%" border="0"><tbody><tr><td style="word-break:break-word;font-size:0px;padding:10px 25px;padding-top:0px;padding-bottom:0px;padding-right:0px;padding-left:0px;" align="left"><table cellpadding="0" cellspacing="0" style="border-collapse:collapse;border-spacing:0px;" align="left" border="0"><tbody><tr><td style="width:200px;"><a href="https://wiseberry.com.au" target="_blank"><img alt="Wiseberry logo" title="" height="auto" src="https://s3-ap-southeast-2.amazonaws.com/wb-docs/EDM-Resources/logo.png" style="border:none;border-radius:;display:block;outline:none;text-decoration:none;width:100%;height:auto;" width="200"></a></td></tr></tbody></table></td></tr></tbody></table></div><!--[if mso | IE]>' +
            '       </td></tr></table>' +
            '           <![endif]--></td></tr></tbody></table></div><!--[if mso | IE]>' +
            '       </td></tr></table>' +
            '           <![endif]-->' +
            '           <!--[if mso | IE]>' +
            '       <table border="0" cellpadding="0" cellspacing="0" width="600" align="center" style="width:600px;">' +
            '             <tr>' +
            '             <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;">' +
            '             <![endif]--><div style="margin:0 auto;max-width:600px;background:#fefefe;"><table cellpadding="0" cellspacing="0" style="font-size:0px;width:100%;background:#fefefe;" align="center" border="0"><tbody><tr><td style="text-align:center;vertical-align:top;font-size:0px;padding:20px 0px;padding-bottom:20px;padding-top:20px;"><!--[if mso | IE]>' +
            '       <table border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:top;width:600px;">' +
            '             <![endif]--><div aria-labelledby="mj-column-per-100" class="mj-column-per-100" style="vertical-align:top;display:inline-block;font-size:13px;text-align:left;width:100%;">' +
            '               <table cellpadding="0" cellspacing="0" style="vertical-align:top;" width="100%" border="0"><tbody><tr><td style="word-break:break-word;font-size:0px;padding:10px 25px;" align="left">' +
            '               <div style="cursor:auto;color:#626262;font-family:Arial, sans-serif;font-size:12px;line-height:14px;">' +
                bodyHTML +
            '           </div>' +
            '           </td></tr><tr><td style="word-break:break-word;font-size:0px;padding:10px 25px;" align="left"><div style="cursor:auto;color:#999999;font-family:Arial, sans-serif;font-size:12px;line-height:14px;">You can only use the personal information contained in this email enquiry for the purposes of contacting the person about their enquiry. You must comply with the Privacy Act 1988 (Cth).' +
            '           </div></td></tr></tbody></table></div><!--[if mso | IE]>' +
            '       </td></tr></table>' +
            '           <![endif]--></td></tr></tbody></table></div><!--[if mso | IE]>' +
            '       </td></tr></table>' +
            '           <![endif]-->' +
            '           <!--[if mso | IE]>' +
            '       <table border="0" cellpadding="0" cellspacing="0" width="600" align="center" style="width:600px;">' +
            '              <tr>' +
            '             <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;">' +
            '             <![endif]--><div style="margin:0 auto;max-width:600px;background:#830b2c;"><table cellpadding="0" cellspacing="0" style="font-size:0px;width:100%;background:#830b2c;" align="center" border="0"><tbody><tr><td style="text-align:center;vertical-align:top;font-size:0px;padding:20px 0px;padding-bottom:0px;padding-top:0px;"><!--[if mso | IE]>' +
            '       <table border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:top;width:600px;">' +
            '             <![endif]--><div aria-labelledby="mj-column-per-100" class="mj-column-per-100" style="vertical-align:top;display:inline-block;font-size:13px;text-align:left;width:100%;"><table cellpadding="0" cellspacing="0" style="vertical-align:top;" width="100%" border="0"><tbody><tr><td style="word-break:break-word;font-size:0px;padding:10px 25px;" align="left"><div style="cursor:auto;color:#ffffff;font-family:Arial, sans-serif;font-size:12px;line-height:22px;">' +
            '             Message sent from <a href="http://wiseberry.com.au/" style="color: #ffffff !important; text-decoration: underline;"><span style="color: #ffffff;">www.wiseberry.com.au</span></a>' +
            '             </div></td></tr></tbody></table></div><!--[if mso | IE]>' +
            '       </td></tr></table>' +
            '           <![endif]--></td></tr></tbody></table></div><!--[if mso | IE]>' +
            '       </td></tr></table>' +
            '           <![endif]-->' +
            '           <!--[if mso | IE]>' +
            '       <table border="0" cellpadding="0" cellspacing="0" width="600" align="center" style="width:600px;">' +
            '             <tr>' +
            '             <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;">' +
            '             <![endif]--><table cellpadding="0" cellspacing="0" style="font-size:0px;width:100%;" border="0"><tbody><tr><td><div style="margin:0 auto;max-width:600px;"><table cellpadding="0" cellspacing="0" style="font-size:0px;width:100%;" align="center" border="0"><tbody><tr><td style="text-align:center;vertical-align:top;font-size:0px;padding:20px 0px;padding-bottom:20px;padding-top:20px;"><!--[if mso | IE]>' +
            '       <table border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:middle;width:600px;">' +
            '             <![endif]--><div aria-labelledby="mj-column-per-100" class="mj-column-per-100" style="vertical-align:middle;display:inline-block;font-size:13px;text-align:left;width:100%;"><table cellpadding="0" cellspacing="0" style="vertical-align:middle;" width="100%" border="0"><tbody><tr><td style="word-break:break-word;font-size:0px;padding:10px 25px;padding-top:0px;padding-bottom:0px;padding-right:25px;padding-left:25px;" align="center"><div style="cursor:auto;color:#000000;font-family:Arial, sans-serif;font-size:11px;line-height:22px;">' +
            '           ©2016 Wiseberry Real Estate' +
            '           </div></td></tr><tr><td style="word-break:break-word;font-size:0px;padding:10px 25px;padding-top:0px;padding-bottom:0px;padding-right:25px;padding-left:25px;" align="center"><div style="cursor:auto;color:#000000;font-family:Arial, sans-serif;font-size:11px;line-height:22px;"> c3/3 Burbank Place Norwest Business Park, Baulkham Hills 2153 NSW Australia' +
            '            </div></td></tr><tr><td style="word-break:break-word;font-size:0px;padding:10px 25px;padding-top:0px;padding-bottom:0px;padding-right:25px;padding-left:25px;" align="center"><div style="cursor:auto;color:#000000;font-family:Arial, sans-serif;font-size:11px;line-height:22px;">Contact: 02 8883 4832 (9.00am - 5.00pm AEST)' +
            '       </div></td></tr></tbody></table></div><!--[if mso | IE]>' +
            '       </td></tr></table>' +
            '           <![endif]--></td></tr></tbody></table></div></td></tr></tbody></table><!--[if mso | IE]>' +
            '       </td></tr></table>' +
            '           <![endif]--></div>' +
            '</body>' +
            '</html>';
            return emailHTML;
        }

        return service;

}]);